import React from "react";
import { Link } from "react-router-dom";
import "../seo/seoPages.css";

const HOME_FAQ = [
  {
    q: "What is an online memorial service?",
    a: "An online memorial service is a lasting memorial website where family and friends can share photos, videos, tributes, and stories anytime—complementing in-person services with ongoing remembrance.",
  },
  {
    q: "Can I create a free memorial website?",
    a: "Yes. You can start with our free memorial website plan and upgrade later for unlimited photos, video galleries, music, and more.",
  },
  {
    q: "Who can view a memorial page?",
    a: "You control privacy settings. Share your memorial page with family and friends and decide how public or private the page should be.",
  },
  {
    q: "Do you serve families outside one state?",
    a: "WillAlwaysLoveU is a virtual memorial service for families across the United States. Our platform is online—no travel required to participate.",
  },
];

export default function HomeSeoSections() {
  return (
    <section className="home-seo-section" aria-labelledby="home-seo-heading">
      <div className="home-seo-inner">
        <h2 id="home-seo-heading">Online memorial resources</h2>
        <nav className="home-seo-links" aria-label="Memorial topics">
          <Link to="/online-memorial-service">Online memorial service</Link>
          <Link to="/create-memorial-website">Create a memorial website</Link>
          <Link to="/online-tribute-and-remembrance">Online tribute page</Link>
          <Link to="/free-memorial-website">Free memorial website</Link>
          <Link to="/guides">Guides & blog</Link>
        </nav>
        <div className="home-seo-faq">
          <h2>Frequently asked questions</h2>
          {HOME_FAQ.map((item) => (
            <details key={item.q}>
              <summary>{item.q}</summary>
              <p>{item.a}</p>
            </details>
          ))}
          <p style={{ marginTop: "1rem" }}>
            <Link to="/faq">View all FAQs →</Link>
          </p>
        </div>
      </div>
    </section>
  );
}
